import { default as MovieCard, MovieCardProps } from '@/components/shared/movie-card';

import { ALLOW_MOVIE_DETAILS_PREFETCH } from '@/constants/prefetch';
import { FC } from 'react';
import Link from 'next/link';
import { useCity } from '@/logic/hooks';

export interface PosterProps extends MovieCardProps {
  link: string;
  // cinemaId?: number;
}

export const Poster: FC<PosterProps> = ({ link, ...props }) => {
  const { cityId: browserCityId } = useCity();

  return (
    <Link
      href={{
        pathname: link,
        // Omit cityId when there is none, rather than emitting `?cityId=` —
        // see the same fix in home-slider/slider-film-info.tsx.
        query: { ...(browserCityId && { cityId: browserCityId }) },
      }}
      legacyBehavior
        passHref
      prefetch={ALLOW_MOVIE_DETAILS_PREFETCH}
    >
      <MovieCard component={'a'} {...props} />
    </Link>
  );
};
